import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DbcOnboardComponent} from './pages/onboard/dbc-onboard.component';
import {PostSignupComponent} from './pages/post-signup/post-signup.component';
import {LoggedInGuard} from '../guards/logged-in.guard';

const routes: Routes = [
    {
        path: '',
        component: DbcOnboardComponent
    },
    {
        path: 'post-signup',
        canActivate: [LoggedInGuard],
        component: PostSignupComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DbcOnboardV2RoutingModule {

}
